import { render, staticRenderFns } from "./instruction-prompt.vue?vue&type=template&id=f155a6c2&scoped=true"
import script from "./instruction-prompt.vue?vue&type=script&lang=js"
export * from "./instruction-prompt.vue?vue&type=script&lang=js"
import style0 from "./instruction-prompt.vue?vue&type=style&index=0&id=f155a6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f155a6c2",
  null
  
)

export default component.exports